module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-31.9171c020.svg";